import * as Sentry from '@sentry/react'
import { useEffect } from 'react'
import {
	createRoutesFromChildren,
	matchRoutes,
	useLocation,
	useNavigationType,
} from 'react-router-dom'

const dsn = import.meta.env.VITE_SENTRY_DSN as string | undefined
const isProd = import.meta.env.PROD
const environment = import.meta.env.MODE

if (dsn && isProd) {
	Sentry.init({
		dsn,
		environment: environment,
		sendDefaultPii: true,
		integrations: [
				Sentry.reactRouterV6BrowserTracingIntegration({
					useEffect,
					createRoutesFromChildren,
					matchRoutes,
					useLocation,
					useNavigationType,
				}),
			Sentry.replayIntegration({
				// Keep /oneapp/* out of this list: those bodies carry the resident's email/phone
				// (the resolve response and the pending-contact token) before consent.
				networkDetailAllowUrls: [],
			}),
		],
		tracesSampleRate: 1.0,
		replaysSessionSampleRate: 0.1,
		replaysOnErrorSampleRate: 1.0,
	})
}


